import { Component } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'

import api from '../../api/api'
import { selectUserData } from '../../reducers/userDataReducer'

import PortalToolbar from './PortalToolbar'
import Notifications from './Notifications'
import NotificationPopup from './NotificationPopup'

class NotificationsPortal extends Component {
  static propTypes = {
    userData: PropTypes.object,
  }

  state = {
    currentTab: 'all',
    allItems: [],
    allFull: false,
    packageItems: [],
    packageFull: false,
    selected: null,
    loading: false,
  }

  componentDidMount() {
    this.handleMore()
  }

  handleTab = (id) =>
    this.setState(
      { currentTab: id },
      () => this.state[`${this.state.currentTab}Items`].length === 0 && this.handleMore(),
    )

  handleMore = () => {
    this.setState({ loading: true })
    const { currentTab, allItems, packageItems } = this.state
    const items = currentTab === 'all' ? allItems : packageItems
    const page = Math.floor(items.length / 10)
    const type = currentTab[0].toUpperCase() + currentTab.substr(1)
    api
      .getNotifications(page, type)
      .then((res) => {
        if (currentTab === 'all') {
          this.setState({
            allItems: [...items, ...res],
            allFull: res.length < 10,
            loading: false,
          })
        } else {
          this.setState({
            packageItems: [...items, ...res],
            packageFull: res.length < 10,
            loading: false,
          })
        }
      })
      .catch(() => this.setState({ loading: false }))
  }

  handleNotification = (item) => this.setState({ selected: item })

  handleClose = () => this.setState({ selected: null })

  render() {
    const { userData } = this.props
    const { currentTab, allItems, packageItems, allFull, packageFull, selected, loading } =
      this.state
    return (
      <div className="ctp-nportal">
        {(userData.user.role === 'Client' || userData.user.role === 'PropertyManager') && (
          <PortalToolbar handleTab={this.handleTab} currentTab={currentTab} />
        )}
        <Notifications
          items={currentTab === 'all' ? allItems : packageItems}
          isFull={currentTab === 'all' ? allFull : packageFull}
          handleMore={this.handleMore}
          handleNotification={this.handleNotification}
          loading={loading}
        />
        {selected && <NotificationPopup handleClose={this.handleClose} item={selected} />}
      </div>
    )
  }
}

export default connect((state) => ({ userData: selectUserData(state) }))(NotificationsPortal)
